import React from 'react';
import PropTypes from 'prop-types';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';

import formClasses from '../../components/common/form/form.module.scss';
import classNames from 'classnames';

import TextField from '../../components/common/form/texField/textField';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import useAuthDataContext from '../../auth/hooks/useAuthDataContext';
import useStyles from './styles';

export default function ForgotPasswordForm({ t }) {
  const classes = useStyles();
  const { goToPage, resetPassword } = useAuthDataContext();

  const initialValues = { email: '' };

  const requiredTranslated = t('form:required');
  const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email(t('form:invalidEmail'))
      .required(requiredTranslated),
  });

  const onSubmit = async (values, actions) => {
    const { success, errorMessage } = await resetPassword(values.email);
    if (success) {
      goToPage('/forgot-password/?success=true');
    } else {
      actions.setStatus({ msg: t(errorMessage) });
    }
  };

  return (
    <div className={formClasses.container}>
      <Formik
        initialValues={initialValues}
        validationSchema={ForgotPasswordSchema}
        onSubmit={onSubmit}
      >
        {({ status, isSubmitting, isValid }) => (
          <Form
            className={classNames(formClasses.paper, formClasses.paperSmall)}
          >
            <div className={formClasses.title}>
              {t('authentication:resetPassword')}
            </div>
            <Field
              name='email'
              required
              component={TextField}
              placeholder={t('authentication:email')}
            />

            {status && status.msg && (
              <Typography className={classes.error}>{status.msg}</Typography>
            )}

            <Button
              className={classes.submitButton}
              variant='contained'
              color='secondary'
              type='submit'
              disabled={!isValid || isSubmitting}
            >
              {t('form:submit')}
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  );
}

ForgotPasswordForm.propTypes = {
  t: PropTypes.func,
};
